module.exports = __webpack_public_path__ + "static/fonts/noto.9082cca.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/noto.ttf
// module id = aj4o
// module chunks = 103